import $ from 'jquery'

const popup = function(text,template) {
    var html = text || 'html text';
    // var bg = document.createElement('div');
    // bg.className = "gt-popup__bg";
    // document.body.appendChild(bg);
    var popupBg =$('<div/>')
                .addClass('gt-popup__bg')
                .appendTo('body')
                .fadeIn(100)
                .on({click: function(){this.remove(); $('body').removeClass('gt-popup__open'); }});

    var popupWrap = $('<div/>').addClass('gt-popup__window')
        .html(html).on({click: function(event){
            // event.preventDefault();
            event.stopPropagation();
            }
        }).appendTo(popupBg);
    var close = $('<i/>')
        .addClass('gt-popup__close fa fa-close')
        .attr('alt', 'close')
        .on({click: function(){popupBg.remove(); $('body').removeClass('gt-popup__open');}})
        .appendTo(popupWrap);
    $('body').addClass('gt-popup__open');
    return html;
};

export default popup;